import Box from "ds/components/Box";
import PageInfoHeader from "ds/components/PageInfoHeader";
import MainNavigationSettingsPage from "components/MainNavigation/components/layout/SettingsPage";

const CustomizeSidebar = () => {
  return (
    <Box direction="column">
      <PageInfoHeader
        title="Sidebar customization"
        caption="Manage your pinned sidebar items here. To pin new items, use the pin button in the main navigation. You can also choose the default view of your account."
      />

      <Box direction="column" padding="x-large" gap="x-large">
        <MainNavigationSettingsPage />
      </Box>
    </Box>
  );
};

export default CustomizeSidebar;
